export const roleData = {
    drafrList : [
        {name:'角色编号',text: 'id'},
        {name:'角色名称',text: 'roleName'},
        {name:'修改人',text: 'updateUser'},
        {name:'创建时间',text: 'createTime'},
    ],
    currentPage:1,
    pageSize: 10,
    total: 0,
    loading: true,
    spreadTable:[],
    tableHeight: 400,
    operation: ['删除','编辑'],
    pageType: 1,
    lastState: 1000,
    filetype: null,
    id:null,
    userInput: ''
}